import React, { Component } from 'react';
import Buttons from '../../../UI/Buttons';
// import Wrp from '../../../hoc/Wrp/Wrp';

class Actions extends Component {
  
    componentDidMount(){
      // console.log(this.props);
    }
    render () {
        const {colData,id} = this.props;
        // Check if any action is disabled
        const hasDisabledAction = Array.isArray(colData) && colData.some(action => action.disabled === true || action.disabled === 1);
        const tdStyle = hasDisabledAction ? { cursor: 'not-allowed' } : {};
        return(
            <td key={"column"+id} style={tdStyle}>   
                <Buttons buttonList={colData} key={"btn"+id}/>
            </td>
        );
    }
}

export default Actions;